import * as React from 'react';
import classnames from 'classnames';

var FormField = function FormField(props) {
  var children = props.children,
      help = props.help,
      error = props.error,
      className = props.className;

  var renderHelp = function renderHelp() {
    var hasErrorMessage = error && error !== true;

    if (!hasErrorMessage && !help) {
      return null;
    }

    var _className = classnames('FormField__help', {
      'FormField__help--error': hasErrorMessage
    });

    return React.createElement("div", {
      className: _className
    }, hasErrorMessage ? error : help);
  };

  var _className = classnames(className, 'FormField', {
    'FormField--error': !!error
  });

  return React.createElement("div", {
    className: _className
  }, React.createElement("div", {
    className: "FormField__input"
  }, children), renderHelp());
};

FormField.displayName = 'Form.Field';
FormField.defaultProps = {
  help: undefined,
  error: undefined,
  className: undefined
};
export default FormField;